<template>
    <div class="m-publish-header">
        <el-page-header @back="goBack">
            <template #content>
                <slot name="prefix"></slot>
                {{ name }}
                <slot></slot>
            </template>
        </el-page-header>
        <div class="m-op">
            <slot name="op"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "publishHeader",
    props: ["name", "backName", "backPath", "pageId"],
    methods: {
        goBack: function () {
            if (this.backName) {
                const data = { name: this.backName };
                if (this.pageId) {
                    data.params = {
                        id: this.pageId,
                    };
                }
                this.$router.push(data);
            } else if (this.backPath) {
                const data = { path: this.backPath };
                this.$router.push(data);
            } else {
                if (window.history.length) {
                    this.$router.go(-1);
                } else {
                    this.$router.push("/");
                }
            }
        },
    },
};
</script>

<style lang="less">
.m-publish-header {
    .pr;
    .el-page-header__content {
        .flex;
        align-items: center;
        gap: 10px;
    }
    .m-op {
        position: absolute;
        right: 0;
        top: 0;
        .flex;
        align-items: center;
        gap: 10px;
        .el-button + .el-button {
            margin-left: 0;
        }
    }
}
</style>
